import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//  const login = r => require.ensure([], () => r(require('page/demo/demo01')), 'demo01')
const home = r => require.ensure([], () => r(require('page/home/home')), 'home')
const api = r => require.ensure([], () => r(require('page/api/api')), 'api')
/* 以这种形式导入组件 */
/* const HomePage = r => require.ensure([], () => r(require('page/HomePage/HomePage')), 'HomePage') */
const bmw = r => require.ensure([], () => r(require('page/case/bmw')), 'bmw')
const zfb = r => require.ensure([], () => r(require('page/case/zfb')), 'zfb')
const baidu = r => require.ensure([], () => r(require('page/case/baidu')), 'baidu')
const navinfo = r => require.ensure([], () => r(require('page/case/navinfo')), 'navinfo')
const ccbus = r => require.ensure([], () => r(require('page/case/ccbus')), 'ccbus')
const gofun = r => require.ensure([], () => r(require('page/case/gofun')), 'gofun')
const Solution = r => require.ensure([], () => r(require('page/solution/solution')), 'solution')
const document = r => require.ensure([], () => r(require('page/document/document')), 'document')
const partner = r => require.ensure([], () => r(require('page/partner/partner')), 'partner')
const authentication = r => require.ensure([], () => r(require('page/authentication/authentication')), 'authentication')
const selfService = r => require.ensure([], () => r(require('page/selfService/selfService')), 'selfService')
// const login = r => require.ensure([], () => r(require('page/login/login')), 'demo')
/* 定义路由 */
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/home'
            // name: 'home',
            // component: home,
            // meta: {requiresAuth: false}
        },
        {
            path: '/home',
            name: 'home',
            component: home,
            meta: {requiresAuth: false}
        },
        {
            path: '/api',
            name: 'api',
            component: api,
            meta: {requiresAuth: false}
        },
        {
            path: '/case/bmw',
            name: 'bmw',
            component: bmw,
            meta: {requiresAuth: false}
        },
        {
            path: '/case/zfb',
            name: 'zfb',
            component: zfb,
            meta: {requiresAuth: false}
        },
        {
            path: '/case/baidu',
            name: 'baidu',
            component: baidu,
            meta: {requiresAuth: false}
        },
        {
            path: '/case/navinfo',
            name: 'navinfo',
            component: navinfo,
            meta: {requiresAuth: false}
        },
        {
             path: '/case/ccbus',
             name: 'ccbus',
             component: ccbus,
             meta: {requiresAuth: false}
        },
        {
            path: '/case/gofun',
            name: 'gofun',
            component: gofun,
            meta: {requiresAuth: false}
        },
        {
            path: '/solution',
            name: 'solution',
            component: Solution,
            meta: {requiresAuth: false}
        },
        {
            path: '/document',
            name: 'document',
            component: document,
            meta: {requiresAuth: false}
        },
         {
            path: '/partner',
            name: 'partner',
            component: partner,
            meta: {requiresAuth: false}
        },
        {
            path: '/authentication',
            name: 'authentication',
            component: authentication,
            meta: {requiresAuth: false}
        },
        {
            path: '/selfService',
            name: 'selfService',
            component: selfService,
            meta: {requiresAuth: false}
        }
        // {
        //     path: '/login',
        //     name: 'login',
        //     component: login,
        //     meta: {requiresAuth: false}
        // }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js